import React from "react";
import { InputType } from "zlib";

interface IInputFieldProps {
  onChange: (e: any) => void;
  value: any;
  label: string;
  extras?: any;
  id: string;
  type?: InputType;
  placeholder?: string;
  customClass?: string;
  containerClass?: string;
  error?:string;
}

const InputField: React.FC<IInputFieldProps> = ({
  extras,
  onChange,
  value,
  label,
  type = "text",
  placeholder = "",
  customClass = "",
  containerClass = "",
  error
}) => (
  <div className={`mb-6 ${containerClass}`}>
    <label
      htmlFor="large-input"
      className={`block mb-2 text-sm font-medium text-gray-900 text-opacity-80`}
    >
      {label}
    </label>
    <input
      type={type}
      id="large-input"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      {...extras}
      className={`block w-full p-2 text-gray-900 border   rounded-md text-base focus:ring-primary focus:border-primary ${customClass} ${!error ? `border-black20` : `border-red-400`}`}
    />
    {error && <div className="pt-1 pl-1 text-sm text-red-600"> {error}</div>}
  </div>
);

export default InputField;
